import React from "react";

export default ({ className = "", children }) => (
  <div className={"bg-white sm:rounded-lg mb-5 " + className}>
    <div className="sm:rounded-lg shadow">
      <div className="w-full px-4 py-5 sm:p-6 text-sm text-gray-500">{children}</div>
    </div>
  </div>
);
